export const Reloads = () => {
    if (!sessionStorage.getItem('startTime')) {
        sessionStorage.setItem('startTime', Date.now());
    };
    const enterTime = sessionStorage.getItem('startTime');
    const addSpend = () => {
        const currentTime = Date.now();
        const spentTime = (currentTime - enterTime) / 1000;
        if (spentTime >= 900) {
            clearInterval(timer);
            sessionStorage.removeItem('startTime');
            window.location.reload();
        };
    };
    const timer = setInterval(addSpend, 900000);
};